import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { TidalButton } from '../common/button';
import useSWR from 'swr';
import * as Yup from 'yup';
import { testImage } from '../../lib/utils';
import { JSONClient, fetcher } from '../../api/bootstrap';
import { MerchantItemForm } from './MerchantItemForm';

const AddItemSchema = Yup.object().shape({
  name: Yup.string()
    .min(1, 'Item name must be at least 1 characters')
    .required('Required'),
  slug: Yup.string()
    .min(1, 'URL Slug must be at least 1 characters')
    .test(
      'no-spaces',
      'slug cannot have spaces',
      (value, context) => !value.includes(' '),
    )
    .required('Required'),
  description: Yup.string()
    .min(1, 'Item description must be at least 1 characters')
    .required('Required'),
  metaDescription: Yup.string()
    .min(1, 'Item meta description must be at least 1 characters')
    .max(200, 'Item meta description must not exceed 200 characters'),
  imageUrl: Yup.string()
    .test('valid-image-url', 'Must use valid image URL', (value) =>
      testImage(value, 1000).then((status) => status === 'success'),
    )
    .required('Required'),
  logoUrl: Yup.string()
    .test('valid-image-url', 'Must use valid image URL', (value) =>
      testImage(value, 1000).then((status) => status === 'success'),
    )
    .required('Required'),
  bannerUrl: Yup.string()
    .test('valid-image-url', 'Must use valid image URL', (value) =>
      testImage(value, 1000).then((status) => status === 'success'),
    )
    .required('Required'),
  categoryId: Yup.string().required('Required'),
  categoryItemOrder: Yup.number()
    .nullable(true)
    .integer('Must be whole number')
    .optional(),
});

const AddItem = ({ onClose }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    if (onClose) {
      onClose();
    }
  };
  const handleShow = () => {
    setShow(true);
  };

  const { data: categories } = useSWR('/market/category');

  const formik = useFormik({
    initialValues: {
      name: '',
      slug: '',
      description: '',
      metaDescription: '',
      imageUrl: '',
      bannerUrl: '',
      logoUrl: '',
      categoryId: '',
      categoryItemOrder: null,
    },
    initialStatus: { message: 'test' },
    validationSchema: AddItemSchema,
    onSubmit: async (values, { setSubmitting, setStatus, setFieldError }) => {
      setSubmitting(true);
      try {
        const res = await fetcher(`/market/item/slug/${values.slug}`);
        if (res?.exists === true) {
          return setFieldError('slug', 'Slug is not unique');
        }

        const { data } = await JSONClient.post(
          `${process.env.SHOP_BACKEND_URI}/market/item`,
          {
            ...values,
          },
        );
        handleClose();
      } catch (error) {
        console.error(error);
        setStatus(error?.response?.data);
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (!show) {
      // if hidden for any reason we should make sure form is reset
      formik.resetForm();
      formik.setStatus('valid');
    }
  }, [show]);

  return (
    <div>
      <TidalButton
        type="info"
        text="Add New Item"
        tint={false}
        onClick={handleShow}
        className="mb-2 hover:opacity-90"
      />
      {show ? (
        <MerchantItemForm
          handleClose={handleClose}
          categories={categories}
          formik={formik}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default AddItem;
